<h1 mat-dialog-title>分成比例</h1>

<mat-divider></mat-divider>

<div class="content">
  <mat-accordion multi>
    <mat-expansion-panel hideToggle *ngFor="let ratio of ratios">
      <mat-expansion-panel-header>
        <mat-panel-title> {{ ratio.name }} </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-list>
        <ng-container *ngFor="let p of ratio.platforms; let i = index">
          <mat-divider *ngIf="i > 0"></mat-divider>

          <mat-list-item>
            <div class="platform" matListItemTitle>
              <app-image [fileid]="p.icon"></app-image> {{ p.name }}
              <div class="spacer"></div>
              <div class="right">
                <div *ngIf="p.first_ratio">
                  首单比例
                  <span class="percent">{{ p.first_ratio | percent }}</span>
                </div>
                <div *ngIf="p.ratio">
                  分成比例
                  <span class="percent">{{ p.ratio | percent }}</span>
                </div>
              </div>
            </div>
          </mat-list-item>
        </ng-container>
      </mat-list>
    </mat-expansion-panel>
  </mat-accordion>
</div>
